module.exports = __webpack_public_path__ + "media/images/pages/sample_brands/brand-verizon-114e2485a0386e1846b2a00ae99d6925.png";